import { addSavedSearch, addSavedSearchEmail, defaultChannels } from './chunk-DBIF5UGD.mjs';

// src/Utils/createSavedSearch/config/utils.ts
var commonSuccess = (response) => {
  return { identity: response?.id ?? `No ID provided on success` };
};
var commonError = (errorResponse) => {
  return {
    error: errorResponse?.errorCode === "UNKNOWN_ERROR" ? `Error response with status: ${errorResponse?.httpStatusCode}` : errorResponse?.errorCode ?? `Error response with status: ${errorResponse?.httpStatusCode}`
  };
};

// src/Utils/createSavedSearch/config/createOnDefault.ts
var createOnDefault = async ({
  payload,
  configCalls
}) => {
  let result = { error: "undefined" };
  const unloggedBody = {
    title: payload?.title,
    email: payload?.email,
    channels: defaultChannels,
    criteria: payload?.search?.criteria,
    searchMetadata: payload?.search?.searchMetadata,
    userInteractionData: payload?.userInteractionData
  };
  const loggedBody = {
    ...payload.search,
    userInteractionData: payload?.userInteractionData
  };
  const success = (response) => {
    result = commonSuccess(response);
  };
  const error = (errorResponse) => {
    result = commonError(errorResponse);
  };
  if (payload?.oauthToken) {
    await addSavedSearch(success, error, {
      config: configCalls,
      authenticationToken: payload.oauthToken,
      body: loggedBody
    });
  } else if (payload?.email) {
    await addSavedSearchEmail(success, error, { config: configCalls, body: unloggedBody });
  } else {
    result = { error: "No token or email provided" };
  }
  while (result.error === "undefined") {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
  return result;
};

export { createOnDefault };
//# sourceMappingURL=chunk-ZS2PV4GN.mjs.map
//# sourceMappingURL=chunk-ZS2PV4GN.mjs.map